import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import Table from "./ClientTable";
import Popup from "reactjs-popup";
import { PopupMessage } from "../../utils/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faPen,
  faPlus,
  faTimes,
  faUndo,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.css";
import styles from "../master.css";
import apiUrl from "../../apiUrlConstant";
import CreatableSelect from "react-select/creatable";
import { Redirect, withRouter, Link } from "react-router-dom";
import { getUserRole, getUserType, clientId, clientAccess } from "../../utils/index";

console.log(clientId(), "clientId")

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};
class ClientDetail extends React.Component {
  groupId = { value: "" };
  state = {
    url: `${apiUrl.apiUrl.url}/client/create`,
    LandlordGroups: [],
    popupContent: "",
    messsagePopup: false,
    delete: false,
    redirect: false,
    id: undefined,
    unitTypes: [],
    assetTypes: [],
    unitSelected: [],
    assetSelected: [],
    modules: [],
    moduleSelected: [],
    initialValues: {
      groupId: "",
      clientName: "",
      clientCategory: getUserType(),
      clientNameId: "",
      groupName: "",
    },
  };

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/client-group/fetch-list`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          LandlordGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/unit-detail/get-unit-types`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          unitTypes: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/unit-detail/get-asset-types`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          assetTypes: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/module/get-all`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          modules: data.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

  }

  checkDelete() {
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/client/check-delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        self.setState({
          messsagePopup: true,
          popupContent: "Sorry you cannot delete this item"
        });
      } else {
        self.setState({
          delete: true
        });
      }
    });
  }

  componentDidUpdate() {
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;
      if (this.props.match.params.id === undefined) {
        this.setState({
          url: `${apiUrl.apiUrl.url}/client/create`,
          unitSelected: [],
          moduleSelected: [],
          assetSelected: [],
          initialValues: {
            groupId: "",
            clientName: "",
            clientCategory: getUserType(),
            clientNameId: "",
            groupName: "",
          },
        });
      } else {
        fetch(
          `${apiUrl.apiUrl.url}/client/fetch-client?id=${this.props.match.params.id}`
        )
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            this.setState({
              url: `${apiUrl.apiUrl.url}/client/update?id=${this.props.match.params.id}`,
              initialValues: data.data,
              unitSelected: data.data.unitTypes,
              moduleSelected: data.data.modules,
              assetSelected: data.data.assetTypes,
            });
            console.log(this.state.initialValues, "iv");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }

  constructor(props) {
    super(props);
  }

  handleChangeAssetType = (newValue, actionMeta) => {
    this.state.assetSelected = [];
    this.state.initialValues.assetTypeId = [];
    for (let i = 0; i < newValue.length; i++) {
      //this.state.initialValues.brandId.push(newValue[i].value);
      this.state.assetSelected.push({
        value: newValue[i].value,
        label: newValue[i].label,
      });
    }
    this.setState({});
  };

  handleFileStorageChange = (newValue, actionMeta) => {
    this.state.initialValues.storageTypeId = newValue.value;
    this.state.initialValues.storageType = newValue.label;
    this.setState({});
  };

  handleChangeUnitType = (newValue, actionMeta) => {
    this.state.unitSelected = [];
    this.state.initialValues.unitTypeId = [];
    for (let i = 0; i < newValue.length; i++) {
      //this.state.initialValues.brandId.push(newValue[i].value);
      this.state.unitSelected.push({
        value: newValue[i].value,
        label: newValue[i].label,
      });
    }
    this.setState({});
  };

  handleChangeModule = (newValue, actionMeta) => {
    console.log(newValue);
    this.state.moduleSelected = [];
    this.state.initialValues.moduleId = [];
    for (let i = 0; i < newValue.length; i++) {
      //this.state.initialValues.brandId.push(newValue[i].value);
      this.state.moduleSelected.push({
        value: newValue[i].value,
        label: newValue[i].label,
      });
    }
    this.setState({});
  };

  handleTypeChange = (newValue, actionMeta) => {
    this.state.initialValues.functionTypeId = newValue.value;
    this.state.initialValues.functionTypeLable = newValue.label;
    this.setState({});
  };

  handleEditableChange = (newValue, actionMeta) => {
    this.state.initialValues.isLeasesEditableId = newValue.value;
    this.state.initialValues.isLeasesEditable = newValue.label;
    this.setState({});
  };

  handleChangeClientGroup = (newValue, actionMeta) => {
    console.group("Value Changed");
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});
    console.log(newValue, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };
  redirectAfterSave = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        groupId: "",
        clientName: "",
        clientCategory: getUserType(),
        clientNameId: "",
        groupName: "",
      },
    });
  };

  redirectAfterEdit = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      unitSelected: [],
      moduleSelected: [],
      assetSelected: [],
      initialValues: {
        groupId: "",
        clientName: "",
        clientCategory: getUserType(),
        clientNameId: "",
        groupName: "",
      },
    });
  };
  redirectToDelete = () => {
    this.setState({ delete: false });
    var ths = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/client/client-delete?id=${this.state.id}`,
    }).then(function (response) {

      if (!response.data.success) {
        ths.setState({
          messsagePopup: true,
          popupContent: "Something Went Wrong",

        });
      } else {
        ths.setState({
          messsagePopup: true,
          popupContent: "Data Deleted Successfully",
        });
      }
    });
  };
  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/client-profile" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <>
      { clientAccess() && (
        <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>
                <Link to="/masters">Masters</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="/masters/client-directory">Client Profile</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="#">Client Profile Setup</Link>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          onSubmit={(values, actions) => {
            values.groupId = this.state.initialValues.groupId;
            values.functionType = this.state.initialValues.functionTypeId;
            values.unitTypes = this.state.unitSelected;
            values.assetTypes = this.state.assetSelected;
            values.fileStorage = this.state.initialValues.storageTypeId;
            values.modules = this.state.moduleSelected;
            console.log(values);
            var self = this;
            axios({
              method: "post",
              url: this.state.url,
              data: values,
            }).then(function (response) {
              if (!response.data.success) {
                actions.setSubmitting(false);
                actions.setErrors(response.data);
              } else {
                self.setState({
                  messsagePopup: true,
                  popupContent: "Data Saved Successfully!"
                });
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (

            <>

              <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">
                      <div className="newGridSectionInner">
                        <label>
                          Client Group <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <CreatableSelect
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="groupId"
                            onChange={(e) => {
                              this.handleChangeClientGroup(e);
                            }}
                            value={{
                              label: this.state.initialValues.groupName,
                              value: this.state.initialValues.groupId,
                            }}
                            options={this.state.LandlordGroups.map((item) => ({
                              label: item.group_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="groupId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Client Name <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            type="text"
                            name="clientName"
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          />
                          <ErrorMessage
                            name="clientName"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Client Category <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="clientCategory"
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          >
                            {getUserType() === "landlord" && (
                              <option value="Landlord" label="Landlord"></option>
                            )}
                            {getUserType() === "occupier" && (
                              <option value="Occupier" label="Occupier"></option>
                            )}
                            {getUserType() !== "occupier" && getUserType() !== "landlord" && (
                              <>
                                <option value="" label="Select"></option>
                                <option value="Landlord" label="Landlord"></option>
                                <option value="Occupier" label="Occupier"></option>
                              </>
                            )}
                          </Field>
                          <ErrorMessage
                            name="clientCategory"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {this.props.match.params.id !== undefined && (
                        <div className="newGridSectionInner">
                          <label>
                            Client Name Id <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Field type="text" name="clientNameId" readonly="true" />
                            <ErrorMessage
                              name="clientNameId"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      )}

                      <div className="newGridSectionInner">
                        <label>
                          Valid From <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field type="date" name="validFrom" />
                          <ErrorMessage
                            name="validFrom"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Valid To <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field type="date" name="validTo" />
                          <ErrorMessage
                            name="validTo"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          No. Of Leases Allowed <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field type="number" name="leasesAllowed" />
                          <ErrorMessage
                            name="leasesAllowed"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Function Type <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="functionType"
                            onChange={(e) => {
                              this.handleTypeChange(e);
                            }}
                            value={{
                              label: this.state.initialValues.functionTypeLable,
                              value: this.state.initialValues.functionTypeId,
                            }}
                            options={[
                              { id: "self", label: "Self" },
                              { id: "clm", label: "CLM" },
                            ].map((item) => ({
                              label: item.label,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="functionType"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          No. of Prospects Allowed <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field type="number" name="prospects" />
                          <ErrorMessage
                            name="prospects"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {typeof this.props.match.params.id == "undefined" && (
                        <>
                          <div className="newGridSectionInner">
                            <label>
                              Asset Types <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <CreatableSelect
                                name="assetType"
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                isMulti
                                onChange={(e) => {
                                  this.handleChangeAssetType(e);
                                }}
                                value={this.state.assetSelected}
                                options={this.state.assetTypes.map((item) => ({
                                  label: item.asset_type,
                                  value: item.id,
                                }))}
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Unit Types <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <CreatableSelect
                                name="unitType"
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                isMulti
                                onChange={(e) => {
                                  this.handleChangeUnitType(e);
                                }}
                                value={this.state.unitSelected}
                                options={this.state.unitTypes.map((item) => ({
                                  label: item.unit_type,
                                  value: item.id,
                                }))}
                              />
                            </div>
                          </div>
                        </>
                      )}


                      <div className="newGridSectionInner">
                        <label>
                          Modules <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <CreatableSelect
                            name="modules"
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            isMulti
                            onChange={(e) => {
                              this.handleChangeModule(e);
                            }}
                            value={this.state.moduleSelected}
                            options={this.state.modules.map((item) => ({
                              label: item.title,
                              value: item.id,
                            }))}
                          />
                        </div>
                      </div>


                      <div className="newGridSectionInner">
                        <label>
                          Active Leases Editable <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="isLeasesEditable"
                            onChange={(e) => {
                              this.handleEditableChange(e);
                            }}
                            value={{
                              label: this.state.initialValues.isLeasesEditable,
                              value: this.state.initialValues.isLeasesEditableId,
                            }}
                            options={[
                              { id: "no", label: "No" },
                              { id: "yes", label: "Yes" },
                            ].map((item) => ({
                              label: item.label,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="isLeasesEditable"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          File Storage <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="storageType"
                            onChange={(e) => {
                              this.handleFileStorageChange(e);
                            }}
                            value={{
                              label: this.state.initialValues.storageType,
                              value: this.state.initialValues.storageTypeId,
                            }}
                            options={[
                              { id: "s3", label: "S3" },
                              { id: "local", label: "Local Server" },
                            ].map((item) => ({
                              label: item.label,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="storageType"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                    </div>

                    {this.props.match.params.id !== undefined ? (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="update_button" disabled={isSubmitting}>
                          Update
                        </button>
                        <button
                          className="delete_button"
                          type="button"
                          onClick={(e) => {
                            this.checkDelete(e);
                          }}
                        >
                          <FontAwesomeIcon icon={faTimes} className="delete_button" /> Delete
                        </button>
                        <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                          Reset
                        </button>
                      </div>
                    ) : (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="add_button" disabled={isSubmitting}>
                          Add
                        </button>
                        <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                          Reset
                        </button>
                      </div>
                    )}
                  </div>
                </Form>
              </div>
            </>
          )}
        </Formik>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              "Delete the item?"
              <a className="close" onClick={this.redirectAfterSave}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Table />
      </>
      )}
      </>
    );
  }
}

export default withRouter(ClientDetail);
